<template>
  <VDialog
    v-model="model"
    lazy
    scrollable
    :contentClass="contentClass"
    :maxWidth="maxWidth"
    :noClickAnimation="noClickAnimation"
    :persistent="persistent"
  >
    <VCard>
      <VToolbar v-if="$slots.title">
        <VToolbarTitle>
          <slot name="title" />
        </VToolbarTitle>
        <VSpacer />
        <VBtn color="primary" flat @click.stop="model = false">
          Close
        </VBtn>
      </VToolbar>
      <VCardText>
        <button v-if="!$slots.title" class="close-btn" color="primary" @click.stop="model = false">
          <VIcon>mdi-close</VIcon>
        </button>
        <slot />
      </VCardText>
      <VCardActions v-if="$slots.actions">
        <slot name="actions" />
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: 'KmModal',

  props: {
    value: Boolean,
    persistent: Boolean,
    noClickAnimation: Boolean,
    contentClass: String,
    maxWidth: String,
  },

  data() {
    return {
      model: this.value,
    }
  },

  watch: {
    model(next) {
      // Propagate model upstream
      if (this.value !== next) this.$emit('input', next)
    },

    value(next) {
      // Apply model from prop
      if (this.model !== next) this.model = next
    },
  },
}
</script>

<style>
.v-overlay--active:before {
  opacity: 0.70;
  background-color: #000;
}
</style>
<style lang="postcss" scoped>
.v-card__text {
  padding: 0;
  overflow-x: hidden;
}
.close-btn {
  opacity: 0.6;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 100;
  &:hover {
    opacity: 1;
  }
}
</style>
